class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* =========================================================
   CONFETE DO CARRINHO (padrão CDR)
   Dispara ao cruzar qualquer meta lida de data-cpb-tiers
   ========================================================= */

(function () {
  if (window.__cdrCpbConfettiInit) return;
  window.__cdrCpbConfettiInit = true;

  var COLORS = [
    '#ff6400',
    '#e0762f',
    '#f79655',
    '#fcb484',
    '#ce6722',
    '#ffffff',
    '#ffd54a'
  ];

  var PIECES = 150;
  var previousCount = null;
  var checkTimer = null;

  function fireConfetti() {
    if (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      return;
    }

    var host =
      document.querySelector('cart-drawer .drawer__inner') ||
      document.querySelector('#CartDrawer') ||
      document.querySelector('cart-drawer') ||
      document.body;

    var rect = host.getBoundingClientRect();
    var top = Math.max(rect.top, 0);
    var height =
      rect.height && rect.height > 0
        ? rect.height
        : window.innerHeight;

    var stage = document.createElement('div');

    stage.className = 'cpb-confetti';
    stage.setAttribute('aria-hidden', 'true');
    stage.style.left = rect.left + 'px';
    stage.style.top = top + 'px';
    stage.style.width =
      (rect.width || window.innerWidth) + 'px';
    stage.style.height = height + 'px';

    document.body.appendChild(stage);

    for (var index = 0; index < PIECES; index += 1) {
      var piece = document.createElement('span');
      var size = 5 + Math.random() * 8;
      var horizontalMovement = Math.random() * 220 - 110;
      var initialRotation = Math.random() * 360;
      var totalSpin = 360 + Math.random() * 540;
      var duration = 2600 + Math.random() * 1700;
      var delay = Math.random() * 950;

      piece.className = 'cpb-confetti__piece';
      piece.style.left = Math.random() * 100 + '%';
      piece.style.top =
        -12 - Math.random() * 60 + 'px';
      piece.style.width = size + 'px';
      piece.style.height =
        size * (0.45 + Math.random() * 0.55) + 'px';
      piece.style.background =
        COLORS[(Math.random() * COLORS.length) | 0];

      if (Math.random() < 0.4) {
        piece.style.borderRadius = '50%';
      }

      stage.appendChild(piece);

      piece.animate(
        [
          {
            transform:
              'translate(0, 0) rotate(' +
              initialRotation +
              'deg)',
            opacity: 1
          },
          {
            transform:
              'translate(' +
              horizontalMovement * 0.6 +
              'px, ' +
              height * 0.85 +
              'px) rotate(' +
              (initialRotation + totalSpin * 0.8) +
              'deg)',
            opacity: 1,
            offset: 0.8
          },
          {
            transform:
              'translate(' +
              horizontalMovement +
              'px, ' +
              (height + 50) +
              'px) rotate(' +
              (initialRotation + totalSpin) +
              'deg)',
            opacity: 0
          }
        ],
        {
          duration: duration,
          delay: delay,
          easing: 'cubic-bezier(.2,.65,.4,1)',
          fill: 'forwards'
        }
      );
    }

    window.setTimeout(function () {
      if (stage && stage.parentNode) {
        stage.parentNode.removeChild(stage);
      }
    }, 5600);
  }

  function checkProgress() {
    var bar = document.querySelector(
      '#CartDrawer [data-cpb-count], cart-drawer [data-cpb-count]'
    );

    if (!bar) return;

    var currentCount = parseInt(
      bar.getAttribute('data-cpb-count') || '0',
      10
    );

    var tiers = (
      bar.getAttribute('data-cpb-tiers') || ''
    )
      .split(',')
      .map(function (value) {
        return parseInt(value, 10);
      })
      .filter(function (value, index, values) {
        return (
          value > 0 &&
          values.indexOf(value) === index
        );
      });

    if (previousCount === null) {
      previousCount = currentCount;
      return;
    }

    var crossedTier = tiers.some(function (tier) {
      return (
        previousCount < tier &&
        currentCount >= tier
      );
    });

    previousCount = currentCount;

    if (crossedTier) {
      fireConfetti();
    }
  }

  function scheduleCheck() {
    window.clearTimeout(checkTimer);

    checkTimer = window.setTimeout(function () {
      checkProgress();
    }, 180);
  }

  function initialize() {
    checkProgress();

    var observer = new MutationObserver(function () {
      scheduleCheck();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'data-cpb-count']
    });
  }

  window.cdrFireCartConfetti = fireConfetti;

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      { once: true }
    );
  } else {
    initialize();
  }
})();
